import { render, staticRenderFns } from "./IndividualSubscriptionRedirectModal.vue?vue&type=template&id=037a72ed&"
import script from "./IndividualSubscriptionRedirectModal.vue?vue&type=script&lang=ts&"
export * from "./IndividualSubscriptionRedirectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports